import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-menu-grp',
  templateUrl: './menu-grp.component.html',
  styleUrls: ['./menu-grp.component.css']
})
export class MenuGrpComponent implements OnInit {
    menuGrpKeyno;

    public menu?: Menu;

    public saving = false;

    public menuGroupNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'translateedit', gotoParms: () => this.menu!.word_id ?? '' }];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.menuGrpKeyno = this.stateService.getStateParams()['menugrp_keyno'];
    }

    private async loadMenu() {
        if (!!this.menuGrpKeyno) {
            this.menu = (await this.datatask.Post(3486, { menugrp_keyno: this.menuGrpKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.menu) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3487, this.menu))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    menugrp_keyno: string;
    menugrp_name: string;
    sortorder: string;
    word_id: string;
}
